import React from "react";
import { type ModelFilterDispatchType, useModelFilterSelector } from "../../../../redux/store";
import { useModelFilterLabel } from "../../../../utils/labels";
import * as Styles from "./styles/StaticFilterBarStyles";
import { IconWrapper } from "../../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import Icon from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import SortFilters from "./SortFilters";
import { showMoreFilters } from "../../../../redux/actions/ModelFiltersActions";
import { ModelFilterId } from "../../../../utils/constants/filterConstants";
import { useDispatch } from "../../../../../../../shared-logic/redux/store";
import { CONTROL_ID_FILTERS } from "../../../../utils/constants/constants";
import { useZoom } from "../../../../../../../shared-logic/hooks/useZoom";

type StaticFilterBarType = { isFixed: boolean };

const StaticFilterBar = ({ isFixed }: StaticFilterBarType): JSX.Element => {
    const dispatch = useDispatch<ModelFilterDispatchType>();
    const showFilters = useModelFilterSelector((state) => state.modelFilters.showMoreFilters);
    const modelFilters = useModelFilterSelector((state) => state.modelFilters);

    // Get filters to get number of active filters
    const filters = Object.values(ModelFilterId).filter((filterId) => modelFilters[filterId].active);

    const allFiltersLabel = useModelFilterLabel("allFilters");

    const isZoomedIn = useZoom();

    return (
        <Styles.Wrapper isFixed={isFixed} data-browser-is-zoomed={isZoomedIn || undefined}>
            <Styles.Inner isFixed={isFixed}>
                <Styles.Item>
                    <Styles.Button
                        type="button"
                        aria-controls={CONTROL_ID_FILTERS}
                        aria-expanded={showFilters}
                        onClick={() => dispatch(showMoreFilters(!showFilters))}
                    >
                        <Styles.ButtonLabel>{allFiltersLabel}</Styles.ButtonLabel>
                        <Styles.ButtonIcon>
                            {filters.length > 0 && isFixed && (
                                <Styles.ButtonIconLabel>{filters.length}</Styles.ButtonIconLabel>
                            )}
                            <IconWrapper>
                                <Icon variant="controls" />
                            </IconWrapper>
                        </Styles.ButtonIcon>
                    </Styles.Button>
                </Styles.Item>
                <Styles.Item>
                    <SortFilters hasNavOffset isFixed={isFixed} />
                </Styles.Item>
            </Styles.Inner>
        </Styles.Wrapper>
    );
};

export default StaticFilterBar;
